import type { User } from '@/domain/User';
import { api } from '@/lib/api';
import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';

export interface CurrentUserResponse {
  data: User;
}

export const currentUserQuery = queryOptions({
  queryKey: queryKeys.user.current(),
  queryFn: async () => {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      throw new Error('No access token available');
    }
    return api.get('user').json<CurrentUserResponse>();
  },
  staleTime: 1000 * 60 * 5, // 5 minutes
});
